import { useEffect, useState } from "react";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
import { useInView } from "react-intersection-observer";
import Promotion from "../../images/Promotion.svg";

const RowPromotion = () => {
  const [refFact1, refFact1InView] = useInView();
  const [refFact1isVisible, setrefFact1IsVisible] = useState(false);
  useEffect(() => {
    if (refFact1InView && !refFact1isVisible) {
      setrefFact1IsVisible(true);
    } else if (!refFact1InView && refFact1isVisible) {
      setrefFact1IsVisible(false);
    }
  }, [refFact1isVisible, refFact1InView]);

  return (
    <div className="color-dk-r">
      <div className="row m-0 flex-row text-center">
        <div className="stickyRowHeaders2 col-lg-4 col-12 d-flex align-items-center justify-content-center">
          <div className="d-lg-none d-inline">
            <div>Customer Promotion Potential (NPS)</div>
          </div>
          <div className="d-none d-lg-block">
            <ParallaxProvider>
              <Parallax
                translateY={[-50, 50]}
                opacity={[1, 0.8]}
                easing="easeOut"
                scale={[0.8, 1]}
              >
                <div>Customer Promotion Potential (NPS)</div>
              </Parallax>
            </ParallaxProvider>
          </div>
        </div>

        <div className="col-lg-8 col-12 text-start color-dk-dark line-height-lg  bg-color-w p-3 p-lg-5">
          <div
            ref={refFact1}
            className={
              refFact1isVisible
                ? "fade-in-section is-visible row m-0 text-center py-2"
                : "fade-in-section row m-0 text-center py-2"
            }
          >
            <div className="px-3">
              <div>
                <h3 className="color-dk-gray mb-3 dk-semi-bold">
                  <spna className="color-dk-r">61.1 % </spna>
                  of customers participated in the NPS survey, were willing to
                  <span className="color-dk-r"> encourage </span>
                  others for shopping on Digikala.
                </h3>
              </div>
              <img src={Promotion} alt="Customer Promotion Potential" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RowPromotion;
